import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  component: {},
  accountPageProfileContainer: {
    width: "100%",
    maxWidth: "800px",
    padding: "60px 16px 16px 16px",
    [theme.breakpoints.down("sm")]: {
      padding: "16px"
    }
  },
  logo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px"
  },
  logoIcon: {
    width: 34,
    height: 34,
    marginRight: "8px",
    color: theme.palette.text.primary
  },
  infoSubmitting: {
    textAlign: "center",
    margin: "28px 0 32px",
    padding: "8px",
    backgroundColor: "rgba(238, 238, 238, 0.5)",
    color: theme.palette.text.primary,
    border: "1px solid #eeeeee",
    [theme.breakpoints.down("sm")]: {
      margin: "12px 0 20px",
      lineHeight: 1
    }
  },
  infoSubmitted: {
    textAlign: "center",
    margin: "28px 0 32px",
    padding: "8px",
    backgroundColor: "#489b77",
    color: theme.palette.common.white,
    border: "1px solid #2d6c51",
    [theme.breakpoints.down("sm")]: {
      margin: "12px 0 20px",
      lineHeight: 1
    }
  },
  infoError: {
    textAlign: "center",
    margin: "28px 0 32px",
    padding: "8px",
    backgroundColor: "rgba(238, 100, 100, 0.5)",
    color: theme.palette.text.primary,
    border: "1px solid rgba(238, 100, 100, 1)"
  },
  infoSubmittedEmail: {
    fontFamily: "SuisseIntlMedium"
  },
  form: {
    display: "flex",
    flexDirection: "column",
    position: "relative"
  },
  formContent: {
    paddingLeft: "32px"
  },
  formGroup: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    },
    [theme.breakpoints.up("md")]: {
      justifyContent: "space-between",
      "& $formControl": {
        maxWidth: "320px"
      }
    }
  },
  formControl: {
    width: "100%"
  },
  formControlHelper: {
    minHeight: "32px"
  },
  formLabel: {
    top: "-4px",
    "&.Mui-focused, &.MuiFormLabel-filled": {
      top: "0px",
      fontSize: "12px"
    },
    "& + .MuiInput-formControl": {
      marginTop: "12px"
    }
  },
  formInput: {},
  formInputPassword: {
    paddingRight: "32px"
  },
  formInputValidated: {
    "&.MuiInput-underline:before, &.MuiInput-underline:hover:not(.Mui-disabled):before":
      {
        borderColor: theme.palette.secondary.dark
      }
  },
  formInputDisabled: {
    "&.MuiInput-underline:before": {
      borderColor: "#aaa",
      borderBottomStyle: "solid"
    }
  },
  formInputIcon: {
    width: "20px",
    height: "20px",
    position: "absolute",
    top: "8px",
    left: "-32px",
    "& path": {
      fill: theme.palette.primary.light
    }
  },
  formInputIconValidated: {
    "& path": {
      fill: theme.palette.secondary.dark
    }
  },
  formPasswordIcon: {
    position: "absolute",
    padding: "0px",
    right: "0px"
  },
  formSelectItem: {
    display: "flex",
    flexDirection: "row",
    "&.Mui-selected, &:hover": {
      backgroundColor: "#f6f6f6"
    }
  },
  formSelectItemIcon: {
    marginRight: "8px"
  },
  formSubmit: {
    padding: "15px",
    marginTop: "32px",
    marginBottom: 30,
    width: "100%",
    borderRadius: "3px",
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontFamily: "SuisseIntlMedium",
    "&.Mui-disabled": {
      color: theme.palette.text.disabled,
      backgroundColor: "#eeeeee"
    },
    "&:hover": {
      backgroundColor: theme.palette.common.black
    }
  },
  formSubmittedBackground: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    backgroundColor: "#fff",
    opacity: "0.3"
  },
  formSubmittedHelp: {
    marginTop: "64px",
    textAlign: "center"
  }
}));
